module.exports = __webpack_public_path__ + "img/offline-shopping-secondary.6ee168af.png";